import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Report } from '../../models/report.model';

@Component({
  selector: 'app-statistiques',
  templateUrl: './statistiques.component.html',
  styleUrls: ['./statistiques.component.scss']
})
export class StatistiquesComponent {
  @Input() statistics!: Report.Statistics;
  @Input() reportId!: string;


  @Output() statisticsEnabled = new EventEmitter<boolean>();

  onEnabled(isEnabled: boolean): void {
    this.statisticsEnabled.emit(isEnabled);
  }
}
